module.exports = __webpack_public_path__ + "img/video-10-bg.4b504110.jpg";